var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 38 39",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "play",
    "aria-hidden": "true",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.305a1 1 0 0 1 0 1.732L16.25 24.8a1 1 0 0 1-1.5-.866v-9.527a1 1 0 0 1 1.5-.866l8.25 4.764Z"
  })));
};
export default SvgPlay;